var __TEMP__ = require('./_metaMap.js');var metaMap = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./noop.js');var noop = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getData;
